// Extending alpine to allow the show/hide toggle to work on mobile only. 
// Using open/close and is/isnt desktop

import { debounce } from './vendor/debounce.js';
import { BP_TABLET } from './_global-variables.js';

export default function filterPanel() {
  return {
    isOpen: false,
    isDesktop: window.innerWidth >= BP_TABLET,
    init() {
      this.handleResize();
      const debouncedResize = debounce(this.handleResize.bind(this), 100);
      window.addEventListener('resize', debouncedResize);
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= BP_TABLET;
      if (!this.isDesktop) {
        this.isOpen = false;
      }
    }
  }
}
